import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { EditTemplateTitleFormValues } from './EditTemplateTitleForm.interface'

const EditTemplateTitleFormContentComponent = () => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<EditTemplateTitleFormValues>
        name="name"
        label="Name"
        placeholder="e.g. Fleet drivers"
      />
    </div>
  )
}

export const EditTemplateTitleFormContent = memo(EditTemplateTitleFormContentComponent)
